module.exports = __webpack_public_path__ + "static/media/mic-record-audio.cd6591c0.png";